import { render, staticRenderFns } from "./loyaltySystem.vue?vue&type=template&id=2b32647c&scoped=true&"
import script from "./loyaltySystem.vue?vue&type=script&lang=js&"
export * from "./loyaltySystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b32647c",
  null
  
)

export default component.exports